import Template from 'backbone/story/templates/assets/story_assets_tab_asset.js.hamlc'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'
import FormattedNumber from 'utils/platform/formatted_number.js'

export default class StoryAssetsTabAssetView extends Backbone.View
  events:
    "click .js-remove-asset" : "onDelete"

  initialize: (options) ->
    @asset = options.asset
    @listenTo(@asset, "change", @render)
    @dispatcher = BackboneDispatcher.get_instance()

  render: ->
    @$el.html Template(
      asset: @asset
      FormattedNumber: FormattedNumber
    )

    this

  onDelete: ->
    @dispatcher.trigger("storyTabAssetDeleted")
    @asset.destroy(success: @remove())



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/assets/story_assets_tab_asset_view.js.coffee